import classNames from 'classnames';
import React from 'react';

import {useRowModel} from 'notebook/tables/store/hooks/useRowModel';
import {ElementMouseEvent} from 'util/Types';

export interface TableGhostCellProps {
  cid: string;
  i: number;
  j: number;
  isHeaderRow: boolean;
  isFillDownBoxLeftEdge: boolean;
  isFillDownBoxRightEdge: boolean;
  isFillDownBoxTopEdge: boolean;
  isFillDownBoxBottomEdge: boolean;
  isSelected: boolean;
}

function TableGhostCell(props: TableGhostCellProps): JSX.Element {
  const {pointerMoveOverCell, startEdit, selectCell} = useRowModel((rowModel) => rowModel.interactions);
  const {i, j} = props;

  const handleMouseDown = (e: ElementMouseEvent): void => {
    e.preventDefault(); // Avoid stealing focus
    selectCell([i, j], {editing: false, collapse: true});
  };

  return (
    <td
      className={classNames('cell', 'is-ghost-cell', {
        'header-cell': props.isHeaderRow,
        'dbl-selected': props.isSelected,
        selected: props.isSelected,
        'is-fillDownBox-leftEdge': props.isFillDownBoxLeftEdge,
        'is-fillDownBox-rightEdge': props.isFillDownBoxRightEdge,
        'is-fillDownBox-topEdge': props.isFillDownBoxTopEdge,
        'is-fillDownBox-bottomEdge': props.isFillDownBoxBottomEdge,
      })}
      // Must have cid here for the floating cell editor to find the position of this cell
      data-cid={props.cid}
      onDoubleClick={() => {
        startEdit([i, j]);
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={() => {
        pointerMoveOverCell([i, j]);
      }}
    >
      <div className="td-padding-fixer">
        <div data-cid={props.cid} className="editable" />
      </div>
    </td>
  );
}

export default React.memo(TableGhostCell);
